import { Link } from "gatsby";
import styled from "styled-components";
import tw, { css } from "twin.macro";

import Button from "../common/Button";

const Wrapper = styled.div<{ buttonWidth?: string }>`
  ${tw`flex flex-row flex-nowrap items-center justify-center lg:justify-start gap-6`}
  font-size: 21px;
  line-height: 30px;

  a.button-primary,
  button.button-primary {
    ${tw`flex-grow-0 box-border items-center text-center font-bold`}
    font-size: 21px;
    width: ${(props) => props.buttonWidth || "225px"};
    height: 74px;
    border-width: 3px;
    border-radius: 8px;
    text-transform: none;

    @media (max-width: 950px) {
      width: ${(props) => props.buttonWidth || "175px"};
      height: 64px;
      font-size: 18px;
    }
  }

  a.roi-calculator {
    ${tw`text-theme-blue-1 font-title whitespace-nowrap font-semibold`}
    text-underline-offset: 9px;

    @media (max-width: 950px) {
      font-size: 18px;
      text-underline-offset: 7px;
    }
  }
`;

interface HeroCtaProps {
  roi?: boolean;
  customerPortal?: boolean; // I'm lazy
}

const HeroCta: React.FunctionComponent<HeroCtaProps> = ({
  roi = false,
  customerPortal = false,
}) => (
  <Wrapper tw="mt-8">
    {customerPortal ? (
      <Button
        tag="a"
        href="https://app.prosperstack.com/sign-up"
        target="_blank"
        rel="noreferrer"
        className="button-primary"
        css={css`
          width: 260px !important;
          @media (max-width: 950px) {
            width: 220px !important;
          }
        `}
      >
        Create a free account
      </Button>
    ) : (
      <>
        <Button className="button-primary get-a-demo">Get a demo</Button>
        {roi && (
          <Link to="/roi-calculator/" className="roi-calculator">
            Calculate my ROI
          </Link>
        )}
      </>
    )}
  </Wrapper>
);

export default HeroCta;
